import { Pipe, PipeTransform } from '@angular/core';

import { integrationErpSistemas } from '../integration-erp-sistema';

@Pipe({
    name: 'integrationErpSistema'
})
export class IntegrationErpSistemaPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = integrationErpSistemas.findIndex(erpSistema => erpSistema.id === value);
        if (index > -1) {
            return integrationErpSistemas[index].nome;
        }
        return '';
    }
}
